// extracted by mini-css-extract-plugin
export default {"tabs":"WiCtThH1oV","full-width":"_1Aont3L5Vi","fullWidth":"_1Aont3L5Vi"};